<ng-container *ngIf="vm$ | async as vm">
  <div class="template-container">
    <div
      class="template-box"
      [class.blank]="isBlankTemplate"
      (click)="handleTemplateClicked.emit(vm.spaceTemplate)"
    >
      <span class="template-icon">
        <svg-icon
          [width]="isBlankTemplate ? '48' : '32'"
          [height]="isBlankTemplate ? '48' : '32'"
          [icon]="isBlankTemplate ? 'blank-add' : vm.spaceTemplate?.icon"
        >
        </svg-icon>
      </span>

      <span class="institution-logo" *ngIf="vm.shouldShowInstitutionLogo">
        <img [src]="vm.institutionLogoUrl" [alt]="vm.institutionName" />
      </span>
    </div>
    <div class="template-body">
      <div class="template-info">
        <span
          class="name"
          [appTooltip]="nameTooltip"
          [appTooltipPlacement]="'bottom-center'"
          [appTooltipDisabled]="vm.spaceTemplate?.name?.length < 19"
        >
          {{ isBlankTemplate ? ('Blank Space' | translate) : vm.spaceTemplate?.name }}
        </span>
        <span class="author" *ngIf="vm.spaceTemplate?.authorName"
          >{{ 'by' | translate }} {{ vm.spaceTemplate?.authorName }}</span
        >

        <ng-template #nameTooltip>
          <app-tooltip [text]="vm.spaceTemplate?.name"> </app-tooltip>
        </ng-template>
      </div>

      <!--    Action Menu-->
      <button
        mat-icon-button
        class="more-icon"
        *ngIf="
          !isBlankTemplate &&
          currentPageView === SpacesHomePageView.ALL_TEMPLATES_VIEW
        "
        (click)="$event.preventDefault(); $event.stopPropagation()"
        [matMenuTriggerFor]="actionMenu"
        #actionMenuTrigger="matMenuTrigger"
        data-name="template-actions-trigger"
        [class.menu-opened]="actionMenuOpened$ | async"
        (menuOpened)="actionMenuOpened$.next(true)"
        (menuClosed)="actionMenuOpened$.next(false)"
      >
        <mat-icon>more_horiz</mat-icon>
      </button>

      <mat-menu #actionMenu="matMenu" xPosition="after" class="pencil-mat-menu light-scheme">
        <!--      Edit Template Button-->
        <app-pencil-menu-item
          *ngIf="!vm.spaceTemplate?.isGeneral"
          [icon]="'edit_menu_icon'"
          [iconConfig]="{ type: IconTypes.svgIcon }"
          [label]="'Edit template' | translate"
          (clickEvent)="onEditButton()"
          data-name="space-template-edit-template-button"
        ></app-pencil-menu-item>

        <!--      Copy Clone URL Button-->
        <app-pencil-menu-item
          [icon]="'link'"
          [iconConfig]="{ type: IconTypes.matIcon }"
          [label]="'Copy Link' | translate"
          (clickEvent)="onCopyCloneUrlButton()"
          data-name="space-template-copy-clone-url-button"
        ></app-pencil-menu-item>

        <!--      Delete Template Button-->
        <app-pencil-menu-item
          *ngIf="!vm.spaceTemplate?.isGeneral"
          [isDanger]="true"
          [icon]="'delete_menu_icon'"
          [iconConfig]="{ type: IconTypes.svgIcon }"
          [label]="'Remove from gallery' | translate"
          (clickEvent)="onDeleteButton()"
          data-name="space-template-delete-template-button"
        ></app-pencil-menu-item>
      </mat-menu>
    </div>
  </div>
</ng-container>
